/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_X13_Request_SentInputs */

const en_portal_x13_request_sent = /** @type {(inputs: Portal_X13_Request_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your request to join the portal has been sent. The agency will review it and reply by email.`)
};

/** @type {(inputs: Portal_X13_Request_SentInputs) => LocalizedString} */
const ar_portal_x13_request_sent = en_portal_x13_request_sent;

/** @type {(inputs: Portal_X13_Request_SentInputs) => LocalizedString} */
const he_portal_x13_request_sent = en_portal_x13_request_sent;

/** @type {(inputs: Portal_X13_Request_SentInputs) => LocalizedString} */
const ur_portal_x13_request_sent = en_portal_x13_request_sent;

/** @type {(inputs: Portal_X13_Request_SentInputs) => LocalizedString} */
const es_portal_x13_request_sent = en_portal_x13_request_sent;

/** @type {(inputs: Portal_X13_Request_SentInputs) => LocalizedString} */
const fr_portal_x13_request_sent = en_portal_x13_request_sent;

/** @type {(inputs: Portal_X13_Request_SentInputs) => LocalizedString} */
const de_portal_x13_request_sent = en_portal_x13_request_sent;

/** @type {(inputs: Portal_X13_Request_SentInputs) => LocalizedString} */
const pt_portal_x13_request_sent = en_portal_x13_request_sent;

/** @type {(inputs: Portal_X13_Request_SentInputs) => LocalizedString} */
const hi_portal_x13_request_sent = en_portal_x13_request_sent;

/** @type {(inputs: Portal_X13_Request_SentInputs) => LocalizedString} */
const bn_portal_x13_request_sent = en_portal_x13_request_sent;

/**
* | output |
* | --- |
* | "Your request to join the portal has been sent. The agency will review it and reply by email." |
*
* @param {Portal_X13_Request_SentInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const portal_x13_request_sent = /** @type {((inputs?: Portal_X13_Request_SentInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_X13_Request_SentInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_portal_x13_request_sent(inputs)
	if (locale === "he") return he_portal_x13_request_sent(inputs)
	if (locale === "ur") return ur_portal_x13_request_sent(inputs)
	if (locale === "es") return es_portal_x13_request_sent(inputs)
	if (locale === "fr") return fr_portal_x13_request_sent(inputs)
	if (locale === "de") return de_portal_x13_request_sent(inputs)
	if (locale === "pt") return pt_portal_x13_request_sent(inputs)
	if (locale === "hi") return hi_portal_x13_request_sent(inputs)
	if (locale === "bn") return bn_portal_x13_request_sent(inputs)
	return /** @type {LocalizedString} */ ("Your request to join the portal has been sent. The agency will review it and reply by email.")
});